import React from 'react'
import { Button, Container, Grid, Typography, CircularProgress } from '@material-ui/core'
import { useCadastro, useSnackBar, useDialog } from '../context/AppContext'
import saveXML from '../services/saveXML'
import sendMail from '../services/sendMail'
import Aviso from '../components/Aviso';
import { onlyNumbers } from '../functions/helpers'
import validaCPF from '../functions/validaCPF'
import validaData from '../functions/validaData'
 
//#region Components
import TxtNomeAssociado from '../components/TxtNomeAssociado'
import TxtTitulo from '../components/TxtTitulo'
import SelectEstadoCivil from '../components/SelectEstadoCivil'
import SelectSexo from '../components/SelectSexo'
import TxtDataNascimento from '../components/TxtDataNascimento'
import TxtEndereco from '../components/TxtEndereco'
import TxtBairro from '../components/TxtBairro'
import TxtCidade from '../components/TxtCidade'
import TxtEstado from '../components/TxtEstado'
import TxtCep from '../components/TxtCep'
import TxtRg from '../components/TxtRg'
import TxtCpf from '../components/TxtCpf'
import TxtTelefone from '../components/TxtTelefone'
import TxtCelular from '../components/TxtCelular'
import TxtEmail from '../components/TxtEmail'
import TipoAssociado from '../components/TipoAssociado'
import SuccessDialog from '../components/SuccessDialog';
//#endregion

export default function AlteraCadastro() {
    const { cadastro } = useCadastro()
    
    const { setSnackBar } = useSnackBar()
    const { setDialog } = useDialog()
    const [saved, setSaved] = React.useState(0)
    const [loading, setLoading] = React.useState(false);

    const handleSave = () => {
        if (!validaCampos()) {
            setSnackBar({ open: true, severity: "warning",
                message: "Alguns dados informados são inválidos." }); 
            setSaved(saved + 1)
            return;
        }   

        setLoading(true)

        saveXML(cadastro)
            .then(() => {  })
            .catch(() => {
                setLoading(false)
                setSnackBar({ open: true, severity: "error",
                    message: "Erro ao Enviar Solicitação de Alteração de Cadastro!"})
                    return
            })
        sendMail(cadastro)
            .then(() => {
                setLoading(false)
                setDialog(true)
                setSaved(0)  
            })
            .catch(() => {
                setLoading(false)
                setSnackBar({ open: true, severity: "error",
                    message: "Erro ao Enviar Solicitação de Alteração de Cadastro!"})
            })
    }

    const validaCampos = () => {
        if (cadastro.titulo === "")
            return false
        if (cadastro.nome === "")
            return false
        if (!validaCPF(onlyNumbers(cadastro.cpf))) 
            return false       
        if (onlyNumbers(cadastro.rg).length < 9)
            return false
        if (!validaData(cadastro.dataNascimento))
            return false
        if (cadastro.cidade === "")
            return false
        if (cadastro.estado === "")
            return false
        if (cadastro.bairro === "")
            return false
        if (cadastro.endereco === "")
            return false
        if (cadastro.cep === "")
            return false
        if (cadastro.email === "")
            return false
            
        return true
    }

    if (!loading)
    {
        return (
            <Container maxWidth="md">
                <Typography variant="h3" style={{ marginTop: "20px" }}>Atualizar Cadastro</Typography>
                <Aviso/>
                <SuccessDialog />
                <form style={{ marginTop: "20px" }}>
                    <Grid container>
                        <TxtTitulo w="15%" ml="0%" saved={saved}/>
                        <TxtNomeAssociado w="45%" ml="10%" saved={saved}/>
                        <TipoAssociado w="20%" ml="10%" saved={saved}/>
                    </Grid>
                    <Grid container style={{ marginTop: '15px' }}>
                        <TxtDataNascimento w="30%" ml="0%" saved={saved}/>
                        <SelectSexo w="25%" ml="10%" saved={saved}/>
                        <SelectEstadoCivil w="25%" ml="10%" saved={saved}/>
                    </Grid>
    
                    <Grid container style={{ marginTop: "15px" }}>
                        <TxtEndereco w="45%" ml="0%" saved={saved}/>
                        <TxtBairro w="45%" ml="10%" saved={saved}/>
                    </Grid>
    
                    <Grid container style={{ marginTop: "15px" }}>
                        <TxtCidade w="35%" ml="0%" saved={saved}/>
                        <TxtEstado w="20%" ml="10%" saved={saved}/>
                        <TxtCep w="25%" ml="10%" saved={saved}/>
                    </Grid>
    
                    <Grid container style={{ marginTop: "15px" }}>
                        <TxtRg w="45%" ml="0%" saved={saved}/>
                        <TxtCpf w="45%" ml="10%" saved={saved}/>
                    </Grid>
    
                    <Grid container style={{ marginTop: "15px" }}>
                        <TxtTelefone w="45%" ml="0%" saved={saved}/>
                        <TxtCelular w="45%" ml="10%" saved={saved}/>
                    </Grid>
    
                    <Grid container style={{ marginTop: "15px" }}>
                        <TxtEmail w="100%" ml="0%" saved={saved}/>
                    </Grid>
                    <Grid container justifyContent="flex-end" style={{ marginTop: "15px" }}>
                        <Button contained onClick={handleSave}>Enviar para Atualização</Button>
                    </Grid>
                </form>
                
            </Container>
        )
    }

    return(<Container>
        <Grid container justifyContent="center" alignItems="center" style={{marginTop: "10%"}}>
            <Typography variant="h2" > Enviando...</Typography>
            <CircularProgress size="50px"></CircularProgress>
        </Grid>
        
    </Container>)
    
}